import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { StringConstants } from '../_constants/stringConstants';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  private currentAppStateSubject: BehaviorSubject<any>;
  public currentAppState: Observable<any>;

  private staticState = {};
  private routeState = {};

  constructor(private storageService: StorageService) {
    this.currentAppStateSubject = new BehaviorSubject<any>({});
    this.currentAppState = this.currentAppStateSubject.asObservable();
  }

  public get currentAppStateData(): any {
    return this.currentAppStateSubject.value;
  }

  setAppStateAttribute(attr, value, skipSessionStorage = false) {
    this.currentAppStateData[attr] = value;
    if (typeof value === 'undefined') {
      delete this.currentAppStateData[attr];
    }
    this.currentAppStateSubject.next(this.currentAppStateData);
    this.storageService.add(attr, value);
  }

  getAppStateAttribute(attr) {
    return this.storageService.get(attr);
  }

  public setStaticState(stateKey, stateVal) {
    this.staticState[stateKey] = stateVal;
  }

  public getStaticState(stateKey) {
    return this.staticState[stateKey];
  }

  public async getLandingState() {
    return this.getAppStateAttribute(StringConstants.LANDING_STATE);
  }

  public clearLandingState(landingStateKey = StringConstants.LANDING_STATE) {
    return this.storageService.remove([landingStateKey]);
  }

  setRouteStateParam(route, data) {
    this.routeState[route] = data;
  }

  getRouteStateParam(route) {
    return this.routeState[route];
  }

  clearRouteStateParam(route) {
    delete this.routeState[route];
  }

  public clearStaticState(stateKey) {
    delete this.staticState[stateKey];
  }


}

